import { ProfessionalIndemnity } from '@insify/design-system/illustrations';
import { Email } from '@insify/design-system/line-icons';
import { Logo } from '@insify/design-system/logo';
import { headingSm, textMd, textXs, textXsSemibold } from '@insify/design-system/typography';
import { BaseModal } from '@insify/modal';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';

import styles from './CrossSellModal.module.css';

type Props = {
  children?: React.ReactNode;
  trackingId: string;
};

export const CrossSellModal: React.FC<Props> = ({ children, trackingId }) => {
  const { t } = useTranslation(['funnel']);

  return (
    <BaseModal
      className={styles.modal}
      backdropClass={styles.backdrop}
      trackingId={trackingId}
      open
      locked
      onClose={() => {}}
    >
      <header className={styles.header}>
        <div className={styles.box}>
          <div className={styles.boxIcon}>
            <Email />
          </div>
          <span className={clsx(textXsSemibold, styles.boxTitle)}>
            <Logo className={styles.logo} />
            {t('cross_sell_header_title')}
          </span>
          <span className={clsx(textXs, styles.boxDescription)}>{t('cross_sell_header_description')}</span>
        </div>
      </header>
      <div className={styles.content}>
        <ProfessionalIndemnity className={styles.illustration} aria-hidden='true' />
        <Trans
          className={clsx(headingSm, styles.contentTitle)}
          i18nKey={'funnel:cross_sell_content_title'}
          parent='h2'
        />
        <Trans
          className={clsx(textMd, styles.contentDescription)}
          i18nKey={'funnel:cross_sell_content_description'}
          parent='p'
        />
        {children}
      </div>
    </BaseModal>
  );
};
